import { Modal } from 'antd';
import { ClockCircleOutlined, WechatOutlined } from '@ant-design/icons';
import { createWXPayQRCode } from '../pages/wechat';
// import CopyToClipboard from './copyToClipboard';

export default ({orderNo, accId, shopId, amount: shouldAmount = 0, onFlowChange: onChange = () => {}}, Info = null) => {
    if(!orderNo || !accId) return false;

    Modal.confirm({
        title: '输入收款金额',
        icon: null,
        content: <div>
            {Info}
            收款金额(可修改)
            <div>
                <input type='number' autoFocus id="amountInput" min={1} defaultValue={shouldAmount} style={{padding: '10px 5px', width: '100%'}} />
            </div>
        </div>,
        okText: '确认金额',
        cancelText: '取消',
        onOk: async () => {
            let realAmount = document.getElementById('amountInput').value;
            realAmount = realAmount < 0 ? 0 : realAmount;
            let content = null;
            let okText = '确定';

            if(realAmount > 0) {
                okText = '已支付';
                let url = await createWXPayQRCode({orderNo, accId, amount: realAmount, shopId});
                content = <div style={{ textAlign: 'center', marginLeft: '-34px' }}>
                    <div>扫码支付金额<span style={{color: 'green'}}>{realAmount}</span>元</div>
                    <img src={url.imageUrl} width={200} alt="" />
                    {/* {url.codeUrl && <div style={{margin: '0 0 20px 0'}}>复制支付链接发送到微信 <CopyToClipboard text={url.codeUrl} /></div>} */}
                </div>;
            }else{
                okText = '确定';
                content = <div style={{ textAlign: 'center', marginLeft: '-34px' }}>确定支付金额<span style={{color: 'red'}}>{realAmount}</span>元？</div>;
            }

            Modal.confirm({
                title: '微信支付',
                icon: <WechatOutlined />,
                content,
                // content: <div style={{ textAlign: 'center' }}>======</div>,
                okText,
                cancelText: '关闭',
                onOk: async () => {
                    // if(realAmount <= 0) {
                    //     let response = await fetch('/api/order-create-als', {
                    //         method: 'POST',
                    //         headers: {
                    //             'Content-Type': 'application/json'
                    //         },
                    //         body: JSON.stringify({
                    //             orderNo,
                    //             payStatus: 2,
                    //         })
                    //    });

                    //    let result = await response.json();

                    //    if(result.success) {
                    //         Modal.success({content: '支付成功！'});
                    //         onChange();
                    //    }else {
                    //         Modal.error(result.data);
                    //    }

                    //    return false;
                    // }
                    onChange();
                }
            })
        }
    });
}